import { getPublicEnvironmentVariables } from '@module/mdrt-org/shared/utils/helpers/get-public-environment-variables';
import { fetchWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/fetch-with-error-handling';

export const getCustomerProfileAdB2CObjectId = async ({
  accessToken,
  personId,
}: {
  accessToken?: string;
  personId?: number;
}): Promise<{ objectId: string }> => {
  if (!accessToken) {
    throw new Error('Access token or person ID is not available');
  }

  const publicEnvironmentVariables =
    typeof window === 'undefined' ? await getPublicEnvironmentVariables() : window.PUBLIC_ENV;

  const apiUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/${
    process.env.NEXT_PUBLIC_API_API_ROUTE
  }/CustomerProfile/${personId}/AdB2CObjectId`;

  return await fetchWithErrorHandling(apiUrl, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Ocp-Apim-Subscription-Key': publicEnvironmentVariables.ocpApiSubscriptionKey ?? '',
    },
  });
};
